import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components/native';

import Touchable from '../../elements/Touchable';

const VendorDescription = ({ description }) => {
  const [showMore, setShowMore] = useState(false);
  const { t } = useTranslation();
  const numberOfLines = 3;
  const onPress = () => {
    setShowMore(!showMore);
  };

  return (
    <S.VendorDescriptionContainer accessibilityRole="button" onPress={onPress}>
      <S.VendorDescriptionTitle>
        {t('vendor-introduction')}
      </S.VendorDescriptionTitle>
      <S.VendorDescriptionText
        numberOfLines={showMore ? undefined : numberOfLines}
      >
        {description}
      </S.VendorDescriptionText>
    </S.VendorDescriptionContainer>
  );
};

const S = {
  VendorDescriptionContainer: styled(Touchable)`
    padding: 16px 12px 16px 16px;
    background-color: ${({ theme }) => theme.palette.white};
  `,
  VendorDescriptionTitle: styled.Text`
    color: ${({ theme }) => theme.palette.warrior};
    font-weight: bold;
    font-size: 15px;
    margin-bottom: 7px;
  `,
  VendorDescriptionText: styled.Text`
    color: ${({ theme }) => theme.palette.warrior};
    font-size: 13px;
  `,
};

export default VendorDescription;
